<template>
<!-- <div class="swiper-slide-inner"> -->
    <div class="step">
        <p>プラン選択</p>
    </div>
    <div class="card_plan-select-container">
        <div class="card_plan-select-wrap _add-gap">

            <!--Card-->
            <div class="card">
                <div class="title">
                    <p class="main"><span>Unit</span></p>
                    <p class="sub"><span>ユニットアカウント（法人利用）</span></p>
                </div>
                <div class="price">
                    <span>0</span>
                    <div>/ 月</div>
                </div>
                <div class="recommend">
                    <span>ショップ / テナント運営</span>
                </div>
                <ul>
                    <li class="list_dot-span"><span>ブランド情報の検索・閲覧</span></li>
                    <li class="list_dot-span"><span>価格軸検索やカテゴリー、ハッシュタグなどの検索機能の利用</span></li>
                    <li class="list_dot-span"><span>ターゲットやプライス等が細かく設定できるこだわり条件検索（検索履歴は保存可能）の利用</span></li>
                    <li><span>ビジネス対象のリスト確認ができる『My Select Room』（お気に入り追加機能）の利用 </span></li>
                    <li><span>ブランドとのチャットが可能な『AUMAトーク』の利用</span></li>
                    <li><span>ブランドからの展示会等のお知らせメールの受信</span></li>
                    <li><span>ブランドに携わるスタッフ紹介『hitotonari.』の閲覧</span></li>
                    <li><span>各種ショップ・飲食・サロン・ギャラリー・宿泊事業運営者・バイヤー・コーディネーター・テナントリーシング・インフルエンサーの方などに最適</span></li>
                </ul>
                    <button type="button" class="btn_link class js-swiper-next" v-on:click="selectPlan(11)"><span>UNITで登録する</span></button>
                    <div class="bg-element"></div>
            </div><!--/.Card-->

            <!--Card-->
            <div class="card">
                <div class="title">
                    <p class="main"><span>Personal</span></p>
                    <p class="sub"><span>パーソナルアカウント（個人利用）</span></p>
                </div>
                <div class="price">
                    <span>0</span>
                    <div>/ 月</div>
                </div>
                <div class="recommend">
                    <span>一般 / 学生</span>
                </div>
                <ul>
                    <li class="list_dot-span"><span>ブランド情報の検索・閲覧</span></li>
                    <li class="list_dot-span"><span>価格軸検索やカテゴリー、ハッシュタグなどの検索機能の利用</span></li>
                    <li class="list_dot-span"><span>ターゲットやプライス等が細かく設定できるこだわり条件検索（検索履歴は保存可能）の利用</span></li>
                    <li><span>ショップ運営や販売に興味のある方に最適</span></li>
                </ul>
                    <button type="button" class="btn_link js-swiper-next" v-on:click="selectPlan(10)"><span>PERSONALで登録する</span></button>
                    <div class="bg-element"></div>
            </div><!--/.Card-->
        </div><!--/.card_plan-select-->
    </div><!--/.DashBoardCardWrap-->
<!-- </div> -->
</template>

<script>
    export default {
        components: {
        },
        methods: {
            selectPlan(plan) {
                    this.$store.state.verify.form.registration_plan = plan;
                    this.$emit('showNextSwiper');
            },
        },
    }
</script>

<style scoped>
.card_plan-select-wrap .card ul li.list_dot-span::after {
    width: 8px;
    height: 8px;
    border: 1px solid;
    border-radius: 100%;
    content: "";
    margin: auto;
    position: absolute;
    top: 5px;
    left: 0;
}
</style>
